export class EdiEdpar{
    isSaved:string;
    rowCheck: boolean;
    ediTpId:string;
    ediTpShiptoCd:string;
    sapPayerNum:string;
    sapShiptoNum:string;
    indirectContactTemplateCd:string;
    directOrdersAllowedFlg:string;
    creationDate:string;
    status:string;
    sapPayerNumOriginal:string;
    ediTpShiptoCdOriginal:string;
    constructor(

        ediTpId : string,
        ediTpShiptoCd : string,
        sapPayerNum : string,
        sapShiptoNum : string,
        indirectContactTemplateCd : string,
        directOrdersAllowedFlg : string,
        sapPayerNumOriginal: string,
        ediTpShiptoCdOriginal:string
    ){

        this.ediTpId =ediTpId ;
        this.ediTpShiptoCd =ediTpShiptoCd ;
        this.sapPayerNum =sapPayerNum ; 
        this.sapShiptoNum = sapShiptoNum;
        this.indirectContactTemplateCd =indirectContactTemplateCd ;
        this.directOrdersAllowedFlg = directOrdersAllowedFlg;
        this.sapPayerNumOriginal=sapPayerNumOriginal;
        this.ediTpShiptoCdOriginal=ediTpShiptoCdOriginal;
        
    }
}